var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVinyl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4091 55.1299V53.9878H46.5509V55.1299H45.4091Z",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3755 55.6978L68.7707 48.8605V37.4653",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3287 37.4653H64.2124V27.2095H73.3287V37.4653Z",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3755 40.3249C54.254 37.8226 50.2917 36.3259 45.9801 36.3259C35.9105 36.3259 27.7476 44.4888 27.7476 54.5584C27.7476 64.628 35.9105 72.7909 45.9801 72.7909C54.0598 72.7909 60.9119 67.5353 63.3046 60.2561",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinyl);
export default __webpack_public_path__ + "static/media/vinyl.be4491ca79244366d0dcaad887eb4da7.svg";
export { ForwardRef as ReactComponent };